'use strict';

var scrollPos = 0;
// adding scroll event
window.addEventListener('scroll', function () {
  // detects new state and compares it with the new one
  if (document.body.getBoundingClientRect().top > scrollPos) {
    document.getElementById('header').classList.add('untuck');
    document.querySelector('body').classList.add('header-untucked');
  } else {
    document.getElementById('header').classList.remove('untuck');
    document.querySelector('body').classList.remove('header-untucked');
  }
  // saves the new position for iteration.
  scrollPos = document.body.getBoundingClientRect().top;
});

if (document.getElementsByClassName('nav-transparent').length) {
  document.querySelector('body').classList.add('nav-transparent');
}

document.addEventListener('DOMContentLoaded', function () {
  fetch('https://parks-project-f522c.firebaseio.com/giveback.json').then(function (response) {
    return response.json();
  }).then(function (t) {
    window.giveback.amount = {
      was: giveback.amount,
      value: t,
      string: Math.round(t).toLocaleString(),
      char: Math.round(t).toLocaleString().split("")
    };
    sessionStorage.setItem("giveback", JSON.stringify(giveback.amount));
    Neptune.liquid.load("giveback");
  });
  document.querySelector('.header__nav').classList.remove('active');
  document.querySelector('body').removeAttribute('data-active-modal');
  document.querySelector('.site-header').classList.add('z-5');
  document.querySelector('.main-content').classList.remove('z-overide');
});